var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('error-dialog', {
    attrs: {
      "status": _vm.loadStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.handleUploadStatus
    }
  }), _vm.handleUploadStatus.pending ? _c('dialog-scroll-lock', {
    attrs: {
      "persistent": "",
      "value": true
    }
  }, [_c('snackbar', {
    attrs: {
      "persistent": "",
      "value": ""
    }
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_vm._v("Uploading file: " + _vm._s(_vm.uploadPct) + "%")]), _c('v-progress-linear', {
    attrs: {
      "color": "white",
      "value": _vm.uploadPct
    }
  }), _c('div')], 1)], 1) : _vm._e(), _c('h1', {
    staticClass: "mt-6 text-h4 text-sm-h3 header-font"
  }, [_vm._v("Secure file transfer")]), _c('div', {
    staticClass: "mt-3 mb-12"
  }, [_vm._v("Store files and transfer them to Ellacard")]), _vm.loadAccountStatus.pending ? _c('div', [_c('v-progress-circular', {
    attrs: {
      "indeterminate": ""
    }
  })], 1) : !_vm.account || !_vm.account.files ? _c('div', {
    staticClass: "warning--text"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v("You don't have permission to access this page ")], 1) : [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "upload-input",
    attrs: {
      "type": "file"
    }
  }), _c('div', {
    staticClass: "d-flex justify-sm-end pa-3"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary",
      "loading": _vm.handleUploadStatus.pending
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("Upload…")])], 1), _c('v-data-table', {
    attrs: {
      "sort-by": "created_at",
      "hide-default-footer": "",
      "headers": [{
        value: 'download',
        sortable: false
      }, {
        text: 'Name',
        value: 'name'
      }, {
        text: 'Created',
        value: 'created_at'
      }, {
        value: 'delete',
        sortable: false
      }],
      "loading": _vm.loadStatus.pending,
      "disable-sort": _vm.loadStatus.pending,
      "disable-pagination": _vm.loadStatus.pending,
      "items": _vm.files
    },
    scopedSlots: _vm._u([{
      key: "item.download",
      fn: function (slot) {
        var _vm$global$profile;
        return [(_vm$global$profile = _vm.global.profile) !== null && _vm$global$profile !== void 0 && _vm$global$profile.admin ? _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function ($event) {
              _vm.copyToClipboard(_vm.getURL(slot.item.key));
            }
          }
        }, [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiClipboardArrowUp)
          }
        })], 1) : _vm._e(), _c('v-btn', {
          attrs: {
            "icon": "",
            "loading": _vm.track == slot.item && _vm.downloadStatus.pending
          },
          on: {
            "click": function ($event) {
              return _vm.download(slot.item);
            }
          }
        }, [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiDownload)
          }
        })], 1)];
      }
    }, {
      key: "item.created_at",
      fn: function (slot) {
        return [_vm._v(" " + _vm._s(_vm._f("moment")(slot.value, 'short-date')) + " ")];
      }
    }, {
      key: "item.delete",
      fn: function (slot) {
        return [_c('v-btn', {
          attrs: {
            "icon": "",
            "loading": _vm.track == slot.item && _vm.deleteFileStatus.pending
          },
          on: {
            "click": function ($event) {
              return _vm.deleteFile(slot.item);
            }
          }
        }, [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiDelete)
          }
        })], 1)];
      }
    }])
  })]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }